export const isNullOrUndefined: (obj: unknown) => boolean = (obj) => {
    return obj === undefined || obj === null;
};
